// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprSinLogoAlternativamente extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.sin_logo.alternativamente";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprSinLogoAlternativamente {
        this.VALUES ??= this.completar({
            "valor": {
                "ca": "alternativament",
                "cs": "alternativně",
                "da": "alternativt",
                "de": "alternativ",
                "el": "εναλλάξ",
                "en": "alternatively",
                "es": "alternativamente",
                "eu": "alternatiboki",
                "fi": "vaihtoehtoisesti",
                "fr": "alternativement",
                "gl": "alternativamente",
                "hi": "वैकल्पिक रूप से",
                "hu": "alternatívan",
                "it": "alternativamente",
                "nl": "alternatief",
                "no": "alternativt",
                "pl": "alternatywnie",
                "pt": "alternativamente",
                "ro": "alternativ",
                "ru": "альтернативно",
                "sv": "alternativt",
                "tr": "alternatif olarak"
            },
            "defecto": "alternativamente"
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
